import React from 'react';
import logo from '../assets/images/coop-logo-white.svg';
import './Layout.css';

// Page header component.
export default function Header(props) {
    return (
            <div className="header" >
                <img src={logo} className="Custom-logo" alt="Co-op" />
            </div>
    )
}